function a(s) {
  return window.o_global && window.o_global.debug && window.o_global.debug.logger && typeof window.o_global.debug.logger == "function" ? window.o_global.debug.logger(s) : {
    trace: () => {
    },
    debug: () => {
    },
    info: () => {
    },
    warn: () => {
    },
    error: () => {
    }
  };
}
const d = a("ft-nav.patternsson.slider"), i = {
  SLIDER_WITH_BUTTONS_MODIFIER: "nav_slider--with-buttons",
  WINDOW: "nav_slider__window",
  BUTTON_LEFT: "nav_slider__button-left",
  BUTTON_RIGHT: "nav_slider__button-right",
  BUTTON_MOBILE: "nav_slider__button-mobile",
  BUTTON_LEFT_VISIBLE_MODIFIER: "nav_slider__button-left--visible",
  BUTTON_RIGHT_VISIBLE_MODIFIER: "nav_slider__button-right--visible",
  BUTTON_MOBILE_VISIBLE_MODIFIER: "nav_slider__button-mobile--visible",
  BUTTON_AIRBAG: "nav_slider__button-airbag"
}, n = {
  WINDOW: "." + i.WINDOW,
  BUTTON_LEFT: "." + i.BUTTON_LEFT,
  BUTTON_RIGHT: "." + i.BUTTON_RIGHT,
  BUTTON_MOBILE: "." + i.BUTTON_MOBILE
}, c = (s, t) => {
  let e = 0;
  return (...o) => {
    e === 0 && t(...o), e += 1, setTimeout(() => {
      e -= 1;
    }, s);
  };
};
class u {
  constructor(t) {
    if (this.element = t, this.windowElement = t.querySelector(n.WINDOW), this.buttonLeft = t.querySelector(n.BUTTON_LEFT), this.buttonRight = t.querySelector(n.BUTTON_RIGHT), this.buttonMobile = t.querySelector(n.BUTTON_MOBILE), this.scrollCallbacks = [], this.windowElement.addEventListener("scroll", c(1e3, this.emitScrollEvent.bind(this)), { passive: !0 }), this.element.classList.add(i.SLIDER_WITH_BUTTONS_MODIFIER), this.updateButtonVisibility(), this.initializeMobileButtonVisibility(), this.buttonLeft.addEventListener("click", this.scrollLeft.bind(this)), this.buttonRight.addEventListener("click", this.scrollRight.bind(this)), this.buttonMobile && this.buttonMobile.addEventListener("click", this.scrollRightOnce.bind(this)), this.windowElement.addEventListener(
      "scroll",
      () => window.requestAnimationFrame(
        () => {
          this.hideMobileButton(), this.updateButtonVisibility();
        }
      ),
      { passive: !0 }
    ), this.windowWidth() === 0) {
      let e = 0;
      const o = setInterval(() => {
        this.windowWidth() !== 0 && (this.updateButtonVisibility(), this.initializeMobileButtonVisibility(), clearInterval(o)), e++, e === 10 && clearInterval(o);
      }, 200);
    }
  }
  windowWidth() {
    return this.windowElement.offsetWidth;
  }
  contentWidth() {
    return this.windowElement.scrollWidth;
  }
  maxScrollLeft() {
    return this.contentWidth() - this.windowWidth();
  }
  scrollWidth() {
    return this.windowWidth() / 3;
  }
  scrollLeft(t) {
    this.windowElement.scrollBy({
      left: -this.scrollWidth(),
      behavior: "smooth"
    });
  }
  scrollRight(t) {
    this.windowElement.scrollBy({
      left: this.scrollWidth(),
      behavior: "smooth"
    });
  }
  scrollRightOnce(t) {
    this.windowElement.scrollBy({
      left: this.scrollWidth() * 2,
      behavior: "smooth"
    }), this.hideMobileButton();
  }
  updateButtonVisibility() {
    if (this.windowWidth() === 0)
      this.hideLeftButton(), this.showRightButton();
    else if (this.contentWidth() > this.windowWidth()) {
      let t = this.windowElement.scrollLeft, e = 3;
      t < e ? (this.hideLeftButton(), this.showRightButton()) : t >= this.maxScrollLeft() - e ? (this.showLeftButton(), this.hideRightButton()) : (this.showLeftButton(), this.showRightButton());
    } else
      this.hideLeftButton(), this.hideRightButton(), d.info("updateButtonVisibility", this.contentWidth(), this.windowWidth());
  }
  initializeMobileButtonVisibility() {
    this.windowWidth() === 0 ? this.showMobileButton() : this.contentWidth() > this.windowWidth() ? this.windowElement.scrollLeft < 3 && this.showMobileButton() : this.hideMobileButton();
  }
  hideLeftButton() {
    this.buttonLeft.classList.contains(i.BUTTON_LEFT_VISIBLE_MODIFIER) && (this.buttonLeft.classList.add(i.BUTTON_AIRBAG), this.buttonLeft.classList.remove(i.BUTTON_LEFT_VISIBLE_MODIFIER), setTimeout(() => {
      this.buttonLeft.classList.remove(i.BUTTON_AIRBAG);
    }, 500));
  }
  hideRightButton() {
    this.buttonRight.classList.contains(i.BUTTON_RIGHT_VISIBLE_MODIFIER) && (this.buttonRight.classList.add(i.BUTTON_AIRBAG), this.buttonRight.classList.remove(i.BUTTON_RIGHT_VISIBLE_MODIFIER), setTimeout(() => {
      this.buttonRight.classList.remove(i.BUTTON_AIRBAG);
    }, 500));
  }
  showLeftButton() {
    this.buttonLeft.classList.add(i.BUTTON_LEFT_VISIBLE_MODIFIER);
  }
  showRightButton() {
    this.buttonRight.classList.add(i.BUTTON_RIGHT_VISIBLE_MODIFIER);
  }
  showMobileButton() {
    const t = this.buttonMobile;
    t && t.classList.add(i.BUTTON_MOBILE_VISIBLE_MODIFIER);
  }
  hideMobileButton() {
    const t = this.buttonMobile;
    t && t.classList.remove(i.BUTTON_MOBILE_VISIBLE_MODIFIER);
  }
  emitScrollEvent(t) {
    this.scrollCallbacks.forEach((e) => {
      e(t);
    });
  }
  registerScrollCallback(t) {
    return this.scrollCallbacks.push(t), t;
  }
}
function I(s) {
  return new u(s);
}
const l = window;
l.o_global ||= {}, l.o_util ||= {};
const { o_global: r } = l, b = r.breakpoint ?? {};
r.globalBreakpoint;
const _ = /*                      */ (s, t, e) => s[t] ?? e, T = (() => {
}), B = /*           */ _(
  r,
  "globalStorage",
  T
);
class w extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.storage = B(window.sessionStorage), this.style.display = "none", this.displayp() && (this.addEventListener("click", this.back), this.show());
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.back);
  }
  back(t) {
    history.back();
  }
  displayp() {
    return b.isSmall() ? !document.referrer.includes(window.location.hostname) || history.length <= 1 ? (this.storage.setItem("nav-refer-back-entry-point", location.href), !1) : this.storage.getItem("nav-refer-back-entry-point") !== location.href : !1;
  }
  show() {
    this.style.display = "inline-block";
  }
}
function L(s, t) {
  customElements.get(s) || customElements.define(s, t);
}
const h = otto.cmp, {
  allowAll: f,
  rejectAll: g,
  togglePreferenceCenter: E,
  resurfaceBanner: O,
  rejectGeneralVendorConsent: R,
  getConsentForGV: m,
  getConsentsForAllGVs: v,
  getIabConsentString: S,
  readVendorsConsents: p,
  readConsentsStates: M,
  archiveReceipt: N,
  emitConsentChangeEvent: W,
  getOttoOwnPurposesConsent: C,
  getAppGoogleTrackingConsent: U,
  getAdjustTrackingConsent: y,
  processAppConsentV2: V,
  consentChanged: k,
  showVendorsList: F,
  __loadOneTrustSDK: D,
  __oneTrustSdkReady: A
} = otto.cmp;
async function G() {
  return await h.getConsentForGV("OTTOT") || await h.getConsentForGV("OTTON");
}
export {
  w as ReferBack,
  L as defineCustomElement,
  G as hasCookieConsent,
  I as initSlider
};
